import { MapperFactory } from '@products/utils/mappers/mapper-factory';
import { Mapper, MapperParams } from '@products/utils/mappers/type.mapper';
import { FundId, ShareClassCode } from '@types';
import { IndexCustomPerformanceDTO } from '../dto/indexes.dto.types';
import { IndexCustomPerformance } from '../model/indexes';

export class IndexCustomPerformanceMapper extends Mapper<IndexCustomPerformance> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(
    indexCustomPerformanceDTO: IndexCustomPerformanceDTO
  ): IndexCustomPerformance {
    return {
      fundId: indexCustomPerformanceDTO.fundid as FundId,
      shareClassCode: indexCustomPerformanceDTO.shareclasscode as ShareClassCode,
      startDate: indexCustomPerformanceDTO.startdate,
      endDate: indexCustomPerformanceDTO.enddate,
      cumulativeReturn: indexCustomPerformanceDTO.cumulativereturn,
    };
  }
}
